const CONSENT_KEY = 'cookie-consent';

export function hasAnalyticsConsent(): boolean {
  return localStorage.getItem(CONSENT_KEY) === 'accepted';
}

export function setAnalyticsConsent(accepted: boolean): void {
  localStorage.setItem(CONSENT_KEY, accepted ? 'accepted' : 'declined');
}